import React from 'react';

export default function UtilitiesHero({ customerName }) {
    return (
        <section className="main-dashboard__hero" id="hero-greeting">
            <h1>Hello, <span>{customerName ?? 'Customer'}</span></h1>
            <p>
                Within the portal, you can access and update your account details, manage your utilities,
                view your usage and download your invoices.
            </p>
        </section>
    );
}